import { ApolloError } from '@apollo/client';
import { InvoiceSummary } from '@finance-hub/domain/invoicing/blocs/types/invoice-summary';
import { transformInvoiceSummary } from '@finance-hub/domain/invoicing/blocs/transformers/invoice-summary-transformer';
import { useGeneratedFinanceHubInvoiceSummaryQuery } from '@finance-hub/domain/invoicing/blocs/documents/invoice-summary.generated';

interface UseInvoiceSummaryLoaderResult {
  error: ApolloError | undefined;
  loading: boolean;
  summary: InvoiceSummary | null;
}

export const useInvoiceSummaryLoader = (): UseInvoiceSummaryLoaderResult => {
  const { data, error, loading } = useGeneratedFinanceHubInvoiceSummaryQuery({
    fetchPolicy: 'cache-and-network',
  });

  return {
    error,
    loading,
    summary: data
      ? transformInvoiceSummary(data.getUnpaidInvoiceSummary)
      : null,
  };
};
